import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import WebsiteSpeedTest from "@/pages/WebsiteSpeedTest";
import CoreWebVitalsCheck from "@/pages/CoreWebVitalsCheck";
import AISnippetsDraftPRs from "@/pages/AISnippetsDraftPRs";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Blog from "@/pages/Blog";
import HowToImproveLCP from "@/pages/blog/HowToImproveLCP";
import CoreWebVitalsGuide from "@/pages/blog/CoreWebVitalsGuide";
import SpeedOptimisationTips from "@/pages/blog/SpeedOptimisationTips";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/auth/callback" element={<App />} />
        <Route path="/website-speed-test" element={<WebsiteSpeedTest />} />
        <Route path="/core-web-vitals-check" element={<CoreWebVitalsCheck />} />
        <Route path="/ai-snippets-draft-prs" element={<AISnippetsDraftPRs />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/how-to-improve-lcp" element={<HowToImproveLCP />} />
        <Route path="/blog/core-web-vitals-guide" element={<CoreWebVitalsGuide />} />
        <Route path="/blog/website-speed-optimisation-tips" element={<SpeedOptimisationTips />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
